import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import NontAuthorized401 from "NontAuthorized401";
import NotificationComposer from "./components/Create";

const SmsNotification = () => {
  const hasToken = Boolean(localStorage.getItem("Token"));

  return (
    <>
      {hasToken ? (
        <DashboardLayout>
          <DashboardNavbar />

          <div className="mt-6 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
            <div className="border-b border-slate-200 bg-gradient-to-r from-amber-50 via-white to-orange-50 p-5 sm:p-6">
              <span className="inline-flex rounded-full border border-amber-200 bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-700">
                SMS / Phone Channel
              </span>
              <h3 className="mt-3 text-xl font-semibold text-slate-900">SMS Notifications</h3>
              <p className="mt-1 text-sm text-slate-600">
                Send short and direct SMS alerts to Customers and Partners.
              </p>
            </div>

            <div className="p-5 sm:p-6">
              <NotificationComposer
                title="SMS"
                channel="sms"
                endpoint="notification/send-sms"
                messageLimit={160}
                messageLabel="SMS Message"
                submitLabel="Send SMS Notification"
              />
            </div>
          </div>
        </DashboardLayout>
      ) : (
        <NontAuthorized401 />
      )}
    </>
  );
};

export default SmsNotification;
